import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    brandTabs: 'All',
    totalPages: 0,
    total: 0,
    size: 0,
    page: 1,
    brandsList: [],
    loaderForButton: false,
    brandsLoading: false,
    activeResult: "grid",
    storeOptions: [],
    integrationTypes: []
}

const brandOnboardSlice = createSlice({
    name: "brandOnboard",
    initialState,
    reducers: {
        setBrandsList(state, action) {
            state.brandsList = action?.payload?.pagination ? [...state.brandsList, ...action.payload?.brandsList] : action.payload?.brandsList
            state.page = action.payload.page || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.brandsLoading = action.payload?.brandsLoading || false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setBrandsLoading(state, actions) {
            state.brandsLoading = actions.payload
        },
        setLoaderForButton(state, actions) {
            state.loaderForButton = actions.payload
        },
        defaultState(state, action) {
            return initialState
        },
        setBrandsStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    }
})

export const brandOnboardActions = brandOnboardSlice.actions;
export default brandOnboardSlice;